import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import React, { Component } from 'react';
import { InputGroup } from 'reactstrap';
import {LatitudeContext} from './MapContext';
import { apiEndpoint } from "helpers/url_helper";


const mapStyles = {
    width: '140%',
    height: '100%',
  };
  const position={
    lat: 60,
    lng: -132.434
  }
  var collection=[];
class DeviceMapContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      collection: [],
      value: 0,
      centre:{},
      position:{}
    }
   
  }
 
render() {
  const positionNew={
    lat: this.context.NewLatitudeValue,
    lng: this.context.NewLongitudeValue,
  }
 //this.setState({position:positionNew});

  console.log("Latitude:------> ",this.context.NewLatitudeValue);
  debugger;
    return (
        <Map
          google={this.props.google}
          zoom={8}
          style={mapStyles}
            initialCenter={{ lat: 18.543, lng: 73.3453}}
          // center={this.state.centre}
        >
        <Marker position={{lat:this.context.NewLatitudeValue, lng:this.context.NewLongitudeValue}}/>
    
      </Map>
    );
  }
}
 
export default DeviceMapContainer;
  DeviceMapContainer.contextType = LatitudeContext;


  